import ImgSpot from '../../components/ImgSpot/ImgSpot';
import MitgliederListe from '../../components/MitgliederListe/MitgliederListe';
import './Mitglieder.css';
import img from '../../assets/VdHR©lisa_hinder_272.jpg';
import { useEffect } from 'react';
function Mitglieder() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div style={{ height: 'calc(100px + 16vh)' }}></div>
      <h1>Mitglieder</h1>
      <MitgliederListe></MitgliederListe>
      <ImgSpot img={img}></ImgSpot>
    </>
  );
}

export default Mitglieder;
